import { Alert } from '@mui/material';

import { CancelIcon } from '@libs/shared/ui/icons';

type Props = {
  text: string;
};

export const AlertError = ({ text }: Readonly<Props>) => (
  <Alert severity="error" icon={<CancelIcon />}>
    {text}
  </Alert>
);
